(async () => {
    const params = new URLSearchParams(window.location.search);
    const variantId = params.get('gift-variant');

    if (!variantId) return;

    /**
     * Refresh all cart-items-component instances
     * using Shopify's Section Rendering API.
     */
    async function refreshCartComponents() {
        const cartComponents = Array.from(
            document.querySelectorAll(
                'cart-items-component[data-section-id]'
            )
        );

        if (!cartComponents.length) return;

        const sectionIds = [
            ...new Set(
                cartComponents
                    .map(component => component.dataset.sectionId)
                    .filter(Boolean)
            )
        ];

        if (!sectionIds.length) return;

        const url = new URL(window.location.href);

        url.search = '';
        url.searchParams.set(
            'sections',
            sectionIds.join(',')
        );

        const response = await fetch(url.toString(), {
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        });

        if (!response.ok) {
            throw new Error('Could not refresh cart sections');
        }

        const sections = await response.json();

        sectionIds.forEach(sectionId => {
            const sectionHTML = sections[sectionId];

            if (!sectionHTML) return;

            const parsedDocument = new DOMParser().parseFromString(
                sectionHTML,
                'text/html'
            );

            const newCartComponent = parsedDocument.querySelector(
                `cart-items-component[data-section-id="${sectionId}"]`
            );

            const currentCartComponent = document.querySelector(
                `cart-items-component[data-section-id="${sectionId}"]`
            );

            if (newCartComponent && currentCartComponent) {
                currentCartComponent.replaceWith(
                    newCartComponent
                );
            }
        });
    }

    try {
        const response = await fetch(
            window.Shopify.routes.root + 'cart/add.js',
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({
                    items: [
                        {
                            id: Number(variantId),
                            quantity: 1
                        }
                    ]
                })
            }
        );

        const responseData = await response.json();

        if (!response.ok) {
            console.error('Could not add gift to cart:', {
                status: response.status,
                variantId,
                response: responseData
            });

            return;
        }

        await refreshCartComponents();

        const cartTrigger = document.querySelector(
            '[data-testid="cart-drawer-trigger"]'
        );

        if (cartTrigger) {
            cartTrigger.click();
        }

    } catch (error) {
        console.error('Gift promotion error:', error);
    }
})();